module.exports = __webpack_public_path__ + "3845b32d987671d446e9654b7dd02407.svg";